/** 60. yıl duayen üyeler sayfası — video kaynağı */
export const DUAYEN_60_VIDEO_URL =
    'https://istanbulrotary.org/img/video/60-Y%C4%B1l.mp4';
